import type { Localization } from '@/app/components/search/common/Localization.ts';

export enum DISTANCE_UNITS {
  KM = 'KILOMETERS',
  M = 'METERS',
  M2 = 'SQUARE_METERS',
  MI = 'MILES',
  FT = 'FEET',
}

export enum WEIGHT_UNITS {
  KG = 'KILOGRAMS',
  G = 'GRAMS',
  LBS = 'POUNDS',
  OZ = 'OUNCES',
}

export type UNITS = DISTANCE_UNITS | WEIGHT_UNITS;

export type PartialLocalization = Pick<Localization, 'lang' | 'locale' | 'country'>;
